var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('navigation-tabs',{class:_vm.$onboarding.tours.MORTGAGE_CALCULATOR.step.AVAILABLE_OFFERS,attrs:{"tabs-headers":_vm.TABS_HEADERS},on:{"change":_vm.onIsShownAvailableProductsChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }